<lib-dynamic-listing
  [module]="'user'"
  [filters]="filterConfigs"
  [columns]="columnConfigs"
  [data]="tableData"
  [actions]="actionConfigs"
  [isLoading]="isLoading"
  [pageIndex]="pageIndex"
  [rowsPerPage]="rowsPerPage"
  [totalCount]="totalCount"
  [totalPages]="totalPages"
  [exportFilename]="exportFilename"
  [showIncludeInactiveCheckbox]="true"
  [includeInactive]="showInactives"
  (filterEvent)="onFilterEvent($event)"
  (actionClicked)="onActionClicked($event)"
  (pageChanged)="onPageChanged($event)"
  (includeInactiveChanged)="showInactives = $event; onShowInactivesChange()"
  (exportCsv)="exportCsv()"
  (exportXlsx)="exportXlsx()"
  (exportPdf)="exportPdf()"
  (columnsSelected)="onColumnsSelected($event)">
</lib-dynamic-listing>

